<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：アカウント通知内容画面(STFMFM02C30)                                                               _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div
    class="overlay"
    id="popup-confirm"
    :class="[isProcessShow ? showClass : hideClass]"
    ref="content"
  >
    <div class="popup" style="width: 875px" ref="refPopup">
      <!-- No5事業者機能利用権限(電帳法) start-->
      <div class="popup-head">電帳法オプションの機能利用の通知</div>
      <!-- No5事業者機能利用権限(電帳法) end-->
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <!-- No5事業者機能利用権限(電帳法) start-->    
        <p>
          事業者に電帳法オプションの機能利用のURLを通知します。
        </p>
        <p>
          ※宛先が複数ある場合は、宛先欄を改行してアドレスを登録してください。
        </p>
        <!-- No5事業者機能利用権限(電帳法) end-->
        <div class="frm-row">
          <span class="frm-label w-50px">
            <strong>宛先</strong>
          </span>
          <textarea
            tabindex="0"
            class="frm-text frm-size-full"
            title=" "
            type="url"
            rows="2"
            maxlength="2000"
            v-model.trim="addresStr"
            v-bind:class="{ error: isErrorMailAddress }"
            ref="mailAddressName"
          >
          </textarea>
        </div>
        <p
          class="errMsg"
          style="margin-left: 60px"
          v-show="errors_mailAddress != ''"
        >
          <ErrorMessageCase :errors="errors_mailAddress"></ErrorMessageCase>
        </p>

        <div class="frm-row">
          <span class="frm-label w-50px">
            <strong>件名</strong>
          </span>
          <input
            tabindex="0"
            type="text"
            class="frm-text frm-size-full"
            maxlength="2000"
            v-model="mailInfo.subject"
            v-bind:class="{ error: isErrorSubject }"
          />
        </div>
        <p
          class="errMsg"
          style="margin-left: 60px"
          v-show="errors_subject != ''"
        >
          <ErrorMessageCase :errors="errors_subject"></ErrorMessageCase>
        </p>

        <div class="frm-row flexalignstart">
          <span class="frm-label w-50px">
            <strong>本文</strong>
          </span>
          <div class="frm-col">
            <div class="frm-item">
              <span class="frm-label">
                <span class="em">{{ strConst1 }}</span
                >様
              </span>
            </div>
            <div class="frm-item">
              <textarea
                tabindex="0"
                class="frm-text frm-size-full"
                rows="6"
                v-model="mailInfo.body"
                maxlength="2000"
                v-bind:class="{ error: isErrorBody }"
              >
              </textarea>
            </div>
            <p class="errMsg" v-show="errors_body != ''">
              <ErrorMessageCase :errors="errors_body"></ErrorMessageCase>
            </p>
            <div class="frm-item">
              <span class="frm-label">
                <span class="em">{{ strConst2 }}</span>
              </span>
            </div>
            <div class="frm-item">
              <textarea
                tabindex="0"
                class="frm-text frm-size-full"
                rows="4"
                maxlength="2000"
                v-model="mailInfo.bodySignature"
                v-bind:class="{ error: isErrorBodySignature }"
              >
              </textarea>
            </div>
            <p class="errMsg" v-show="errors_bodySignature != ''">
              <ErrorMessageCase
                :errors="errors_bodySignature"
              ></ErrorMessageCase>
            </p>
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <p class="aligncenter">
            <label class="frm-checkbox">
              <input
                type="checkbox"
                v-model="mailInfo.accountingOfficeNotification"
              />
              <span
                tabindex="0"
                class="checkbox-item"
                @keydown.space.stop.prevent="
                  mailInfo.accountingOfficeNotification =
                    !mailInfo.accountingOfficeNotification
                "
              ></span>
              <!-- No5事業者機能利用権限(電帳法) start-->
              <span class="checkbox-text"
                >この通知を税理士事務所メールアドレスにも送信する</span
              >
              <!-- No5事業者機能利用権限(電帳法) end-->
            </label>
          </p>
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button tabindex="0" class="frm-btn strong large" @click="send">
                通知する
              </button>
              <button
                tabindex="0"
                class="frm-btn large"
                @click="cancelSend"
                @blur="onblur"
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import Common from "@/util/common.js";
import Validation from "@/util/validation.js";
import { mapMutations } from "vuex";
import { API_STFMFM02C30_SendMail } from "@/api/Modules/FM02/STFMFM02C30.js";
export default {
  name: "AccountNotificationContentModal",
  components: {
    ErrorMessage,
    ErrorMessageCase,
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      addresStr: "",
      errors: [],
      errors_mailAddress: [], // エラー情報_宛先
      errors_subject: [], // エラー情報_件名
      errors_body: [], // エラー情報_本文上段
      errors_bodySignature: [], // エラー情報_本文下段
      isErrorMailAddress: false,
      isErrorSubject: false,
      isErrorBody: false,
      isErrorBodySignature: false,
      strConst1: "",
      strConst2: "",
      mailInfo: {
        mailAddressList: [], // 宛先
        subject: "", // 件名
        body: "", // 本文上段
        bodySignature: "", // 本文下段
        accountingOfficeNotification: true, // 税理士事務所通知チェック
      },
      TatsuzinInfoUrl: Common.getSettingsValue("TatsuzinInfoUrl"),
      count: 0,
      wbusinessOperatorId: 0,
    };
  },
  props: {
    isProcessShow: {
      type: Boolean,
      required: true,
    },
    //事業ID
    businessOperatorId: {
      type: Number,
      required: true,
    },
    // 税理士事務所名
    accountingOfficeName: {
      type: String,
      required: true,
    },
    // 事業者名
    businessOperatorName: {
      type: String,
      required: true,
    },
    mailAddress: {
      type: String,
      required: true,
    },
  },

  mounted() {},
  computed: {},
  watch: {
    accountingOfficeName: function (val) {
      this.mailInfo.subject = Common.getMessage("MTFM8030", [
        val,
        "",
      ]); // 税理士事務所名
    },
    businessOperatorId: function (val) {
      this.wbusinessOperatorId = val; // 事業ID
    },
    isProcessShow: function (newVal) {
      if (newVal) {
        this.strConst1 = Common.getMessage("MTFM8010", []);
        this.strConst2 = Common.getMessage("MTFM8020", []);
        this.addresStr = this.mailAddress.trim();
        this.mailInfo.subject = Common.getMessage("MTFM8030", [
          this.accountingOfficeName,
          "",
        ]); // 件名
        this.mailInfo.body = Common.getMessage("MTFM8040", []); // 本文
        this.mailInfo.bodySignature = Common.getMessage("MTFM8050", []); // 本文下段

        this.mailInfo.accountingOfficeNotification = true; // 税理士事務所通知チェック
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    ...mapMutations("businessModule",["processDialogue"]),
    onblur(e) {
      Common.onblur(e, this);
    },

    // **********************************************
    // * 送信が選択された時の処理
    // **********************************************
    send() {
      this.errors = [];
      this.errors_mailAddress = []; // エラー情報_宛先
      this.errors_subject = []; // エラー情報_件名
      this.errors_body = []; // エラー情報_本文上段
      this.errors_bodySignature = []; // エラー情報_本文下段

      // -------- 宛先チェック --------
      this.isErrorMailAddress = false;
      
      // 必須チェック
      if (!this.addresStr.replace("\n", "")) {
        this.isErrorMailAddress = true;
        this.errors_mailAddress.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["宛先"])
          )
        );
      }
      // 宛先メールアドレスチェック
      let mailList = this.addresStr.split("\n");

      if (
        mailList[mailList.length - 1] == "" ||
        mailList[mailList.length - 1] == null ||
        mailList[mailList.length - 1] == undefined
      ) {
        mailList.pop();
      }
      for (var item of mailList) {
        var isMailCheck = Validation.isMail(item);
        if (!isMailCheck) {
          this.isErrorMailAddress = true;
          this.errors_mailAddress.push(
            Common.createError(
              "MTCL1015",
              Common.getMessage("MTCL1015", ["メールアドレス"])
            )
          );
        }
      }
      if(!this.isErrorMailAddress){
        // 重複チェック
        let mailSet = new Set(mailList);
        if(mailSet.size != mailList.length){
          this.isErrorMailAddress = true;
            this.errors_mailAddress.push(
              Common.createError(
                "MTCL1082",
                Common.getMessage("MTCL1082", [])
              )
            );
        }
      }
      this.mailInfo.mailAddressList = this.addresStr.split("\n");

      // -------- 件名チェック --------
      this.isErrorSubject = false;

      // 必須チェック
      if (!this.mailInfo.subject.replace("\n", "")) {
        this.isErrorSubject = true;
        this.errors_subject.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["件名"])
          )
        );
        // 入力禁止文字チェック
      } else if (Validation.containsHalfKatakana(this.mailInfo.subject)) {
        this.isErrorSubject = true;
        this.errors_subject.push(
          Common.createError(
            "MTCL1018",
            Common.getMessage("MTCL1018", ["件名", "半角カタカナ"])
          )
        );
      }

      // -------- 本文上段チェック --------
      this.isErrorBody = false;
      
      // 必須チェック
      if (!this.mailInfo.body.replace(/\r?\n/g, "")) {
        this.isErrorBody = true;
        this.errors_body.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["本文上段"])
          )
        );

        // 入力禁止文字チェック
      } else if (Validation.containsHalfKatakana(this.mailInfo.body.replace(/\r?\n/g, ""))) {
        this.isErrorBody = true;
        this.errors_body.push(
          Common.createError(
            "MTCL1018",
            Common.getMessage("MTCL1018", ["本文上段", "半角カタカナ"])
          )
        );
      }

      // -------- 本文下段チェック --------
      this.isErrorBodySignature = false;

      // 必須チェック
      if (!this.mailInfo.bodySignature.replace(/\r?\n/g, "")) {
        this.isErrorBodySignature = true;
        this.errors_bodySignature.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["本文下段"])
          )
        );
        // 入力禁止文字チェック
      } else if (Validation.containsHalfKatakana(this.mailInfo.bodySignature.replace(/\r?\n/g, ""))) {
        this.isErrorBodySignature = true;
        this.errors_bodySignature.push(
          Common.createError(
            "MTCL1018",
            Common.getMessage("MTCL1018", ["本文下段", "半角カタカナ"])
          )
        );
      }

      if (
        this.isErrorMailAddress ||
        this.isErrorSubject ||
        this.isErrorBody ||
        this.isErrorBodySignature
      ) {
        this.errors.push(
          Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
        );
        this.$refs.refPopup.scroll({ top: 0, behavior: 'smooth' });
        return;
      }
      this.errors = [];
      // 「処理中」表示
      this.processDialogue(true);
      const param = {
        businessOperatorId: this.wbusinessOperatorId,
        businessOperatorName: this.businessOperatorName,
        sendFlg: this.mailInfo.accountingOfficeNotification,
        addressList: this.mailInfo.mailAddressList,
        subject: this.mailInfo.subject,
        body: this.mailInfo.body,
        bodySignature: this.mailInfo.bodySignature,
      };
      // メール送信
      //this.$emit("send", this.mailInfo);
      API_STFMFM02C30_SendMail(param).then((response) => {
        this.processDialogue(false);
        // 正常終了の場合
        if (_.eq(response.result, "0000")) {
          this.cancelSend(true);
        } else {
          // エラー表示
          if (response.errorMSG) {
            this.errors.push(
              Common.createError(response.errorCD, response.errorMSG)
            );
          } else {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
      });
    },
    // **********************************************
    // * キャンセルが選択された時の処理
    // **********************************************
    cancelSend(isReturn=false) {
      this.reset();
      this.$emit("cancelSend", isReturn);
    },
    // **********************************************
    // * リセット
    // **********************************************
    reset() {
      this.strConst1 = "";
      this.mailInfo.subject = "";
      this.mailInfo.body = "";
      this.mailInfo.bodySignature = Common.getMessage("MTCL2015", []); // 本文下段
      this.mailInfo.accountingOfficeNotification = true; // 税理士事務所通知チェック
      this.errors = [];
      this.errors_mailAddress = []; // エラー情報_宛先
      this.errors_subject = []; // エラー情報_件名
      this.errors_body = []; // エラー情報_本文上段
      this.errors_bodySignature = []; // エラー情報_本文下段
      this.isErrorSubject = false;
      this.isErrorBody = false;
      this.isErrorBodySignature = false;
      this.isErrorMailAddress = false;
    },
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.mailAddressName.focus();
    },
  },
};
</script>
